import { jsx as _jsx } from "react/jsx-runtime";
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
export const LocaleSwitcher = ({ currentLocale, displayText, disabled = false, onLocaleChange, }) => {
    const handleLocaleChange = () => {
        if (disabled)
            return undefined;
        const newLocale = currentLocale === 'cs' ? 'en' : 'cs';
        onLocaleChange?.(newLocale);
    };
    return (_jsx(PlainButton, { disabled: disabled, onClick: handleLocaleChange, children: _jsx(Text, { variant: 'b2', color: 'action', children: displayText }) }));
};
